export enum ChartAggregationType {
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
  Year = 'Year',
}
